import React, { useState } from "react";
import axios from "axios";

const ApointmentForm = () => {
  const [AppointmentData, setAppoinmentData] = useState({
    firstname: "",
    lastname: "",
    email_id: "",
    mobileno: "",
    appoinment_date: "",
    address: "",
  });

  const [message, setMessage] = useState(""); // 
  const [isError, setIsError] = useState(false);

  const collectdata = (e) => {
    setAppoinmentData({
      ...AppointmentData,
      [e.target.name]: e.target.value,
    });
  };

  const handleaddappoinment = async () => {
    const {
      firstname,
      lastname,
      email_id,
      mobileno,
      appoinment_date,
      address,
    } = AppointmentData;


    if (
      !firstname.trim() ||
      !lastname.trim() ||
      !email_id.trim() ||
      !mobileno.trim() ||
      !appoinment_date.trim() ||
      !address.trim()
    ) {
      setIsError(true);
      setMessage("Please Fill Your Details");
      return;
    }

    try {
      const body = {
        firstname,
        lastname,
        email_id,
        mobileno,
        appoinment_date,
        address,
      };

      const response = await axios.post("https://psynexa-backend.onrender.com/book/appointment", body);

      if (response.status === 200 || response.status === 201) {
        setIsError(false);
        setMessage("Your appointment has been booked successfully.");

        // Reset form
        setAppoinmentData({
          firstname: "",
          lastname: "",
          email_id: "",
          mobileno: "",
          appoinment_date: "",
          time: "",
          address: "",
        });
      }
    } catch (error) {
      console.error("Error:", error.message);
      setIsError(true);
      setMessage("Failed to book appointment. Please try again.");
    }
  };

  return (
    <>
      <div className="min-w-lg mx-auto mt-10 sm:mt-28 bg-gradient-to-b from-[#469B8F] to-transparent p-8 rounded-xl shadow-lg">
        <h2 className="text-2xl font-bold text-white font-roboto mb-6 text-center">
          Get Appointment
        </h2>



        <div className="space-y-6">
          <div className="sm:flex md:flex justify-between gap-3">
            <div className="w-full">
              <label className="block mb-1 font-roboto text-white font-medium">First Name</label>
              <input
                type="text"
                name="firstname"
                value={AppointmentData.firstname}
                onChange={collectdata}
                placeholder="Your first name"
                className="w-full font-roboto border rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-700"
              />
            </div>
            <div className="w-full">
              <label className="block mb-1 font-roboto text-white font-medium">Last Name</label>
              <input
                type="text"
                name="lastname"
                value={AppointmentData.lastname}
                onChange={collectdata}
                placeholder="Last name"
                className="w-full border font-roboto rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-700"
              />
            </div>
          </div>

          <div className="sm:flex md:flex justify-between gap-3">
            <div className="w-full">
              <label className="block mb-1 font-roboto text-white font-medium">Email</label>
              <input
                type="email"
                name="email_id"
                value={AppointmentData.email_id}
                onChange={collectdata}
                placeholder="Email"
                className="w-full border font-roboto rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-700"
              />
            </div>
            <div className="w-full">
              <label className="block mb-1 text-white font-roboto font-medium">Mobile Number</label>
              <input
                type="text"
                name="mobileno"
                value={AppointmentData.mobileno}
                onChange={collectdata}
                placeholder="Mobile Number"
                className="w-full border font-roboto rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-700"
              />
            </div>
          </div>

          <div className="sm:flex md:flex justify-between gap-3">
            <div className="w-full">
              <label className="block mb-1 text-white font-roboto font-medium">Appointment Date</label>
              <input
                type="date"
                name="appoinment_date"
                value={AppointmentData.appoinment_date}
                onChange={collectdata}
                className="w-full border font-roboto rounded-xl px-4 py-2 focus:outline-none  focus:ring-2 focus:ring-emerald-700"
              />
            </div>
            
          </div>

          <div>
            <label className="block mb-1 text-white font-roboto font-medium">Address</label>
            <textarea
              name="address"
              placeholder="Address"
              value={AppointmentData.address}
              onChange={collectdata}
              className="w-full border font-roboto rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-emerald-700"
            />
          </div>

          <button
            type="submit"
            onClick={handleaddappoinment}
            className="w-full bg-[#469B8F] font-roboto font-semibold text-black py-2 rounded-full transition"
          >
            Submit
          </button>
          {/*  Success/Error Message */}
          {message && (
            <p className={`text-center mb-4 text-lg font-roboto font-semibold ${isError ? "text-red-500 underline" : "text-green-500"}`}>
              {message}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ApointmentForm;
